export const Features = {
  FinancialModelling: false,
  BaseCampLayout: true, // TODO - remove
  QrCode: true, // TODO - remove
  Files: true,
  PdfToRules: true,
  MarkdownEditor: true,
  StripeSandbox: false,
  OriginalGamePage: false, // TODO - remove
  Tasks: true, // TODO - remove
  PremiumMode: true,
  BggRank: true, // TODO - remove
  StorageFooter: true,
  SwitchAccount: false,
  QuickSearchPublishers: true,
  PublisherResearch: true,
  PublisherFitForGame: false,
  NestiFyzMigration: true,
  Eula: true,
};
